import React, { Component } from 'react'
import styled from 'styled-components'
import { Button } from 'advenio-components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BalanceTable from '../../Components/ParentPlatform/BalanceTable'
import BalanceActions from '../../Data/Redux/ParentPlatform/BalanceRedux'
import { Selectors } from '../../Data/Redux/ParentPlatform/ChildrenRedux'

const GetMoreContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 8px 0px;
  background-color: white;
`

class Balance extends Component {
  state = {
    page: 1,
    activeChildId: null,
    hasMore: false,
    child: {
      currency: {
        symbol: '$',
        code: 'MXN',
      },
    },
  }

  componentWillMount = () => {
    this.props.getBalance(this.props.activeChildId, 1)
  }

  componentDidMount = () => {
    const { balance, children, activeChildId } = this.props

    document.querySelector('body').style.height = 'auto'
    document.querySelector('body').style.overflow = 'auto'
    document.querySelector('#root').style.height = 'auto'
    document.querySelector('#root').style.overflow = 'auto'

    if (children && activeChildId) {
      const [child] = children.filter(child => activeChildId === child.id)

      this.setState({
        activeChildId,
        child,
        page: 1,
      })
    }

    // if (balance.data) {
    //   this.setState({ hasMore: (balance.length % 15) === 0 })
    // }
  }

  componentWillReceiveProps = ({ activeChildId, balance, children }) => {
    const { activeChildId: oldChildId, getBalance } = this.props
    let hasMore =false
    // if(balance){
    //    hasMore = (balance.data.length % 15) === 0 && balance.data.length > 0
    // }
    const [child] = children.filter(child => activeChildId === child.id)

    if (activeChildId !== oldChildId) {
      this.setState(
        { activeChildId, page: 1, child },
        () => getBalance(activeChildId, 1)
      )
    } else {
      this.setState({ hasMore })
    }
  }

  getMore = (pageSelected) => {
    const { getMore } = this.props
    const {  activeChildId } = this.state
    this.setState({
      page: pageSelected,
    }, () => getMore(activeChildId, pageSelected))
  }

  handleKidSelect = (child) => {
    const { getBalance } = this.props

    this.setState({
      activeChildId: child.id,
      page: 1,
      child,
    }, () => getBalance(child.id, 1))
  }
  render() {
    const { balance, loading } = this.props
    const { child ,page} = this.state

    return (
      <div>
        <BalanceTable
          balance={balance}
          child={child}
          loading={loading}
          pageSelected={page}
          getMore={this.getMore}
        />
        {/* <GetMoreContainer>
          <Button
            onClick={this.getMore}
            primary={!loading && hasMore}
            transparent={!hasMore || loading}
            loading={loadingMore}
            disabled={loading || !hasMore}
          >
            Ver más
          </Button>
        </GetMoreContainer> */}
      </div>
    )
  }
}

Balance.propTypes = {
  /** The ID of the active student */
  activeChildId: PropTypes.number,
  /** The active student's account transactions */
  balance: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  /** The children to whom the activity can be registered */
  children: PropTypes.array,
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** Fetch the current student's account balance details */
  getBalance: PropTypes.func.isRequired,
  /** Fetch the next page of the current student's account balance details */
  getMore: PropTypes.func.isRequired,
}

Balance.defaultProps = {
  activeChildId: null,
  children: [],
  balance:[],
}

const mapStateToProps = (state) => {
  const { parent_platform_balance, parent_platform_children } = state

  return ({
    children: parent_platform_children.get.results,
    loading:  parent_platform_balance.getting.fetching||parent_platform_balance.get.fetching ,
    activeChildId: parent_platform_children.activeChildId,
    activeChild: Selectors.activeChild(state),
    balance: parent_platform_balance.get.results,
  })
}

const mapDispatchToProps = dispatch => ({
  getBalance: (studentId, page) => dispatch(BalanceActions.getRequest({ studentId, page }, true)),
  getMore: (studentId, page) => dispatch(BalanceActions.getMoreRequest({ studentId, page })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Balance)



// WEBPACK FOOTER //
// ./src/Containers/ParentPlatform/Balance.jsx